export function getBaseUrl() {
  //return 'http://localhost:49211/';
  return "//map.cizhuangyuan.com/jk/"
}